/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2020-01-10 00:00:00
 *
 *******************************************************/
// @flow

import { getJSON } from 'redux-api-middleware';
import { I18n } from '@shopify/react-i18n';
import { processRes } from 'src/helpers/actions-helper';

import apiService from 'src/services/api-service';
import {
  GET_VARIANTS_DISPLAY_REQUEST,
  GET_VARIANTS_DISPLAY_SUCCESS,
  GET_VARIANTS_DISPLAY_FAILURE,
  UPDATE_VARIANTS_DISPLAY_REQUEST,
  UPDATE_VARIANTS_DISPLAY_SUCCESS,
  UPDATE_VARIANTS_DISPLAY_FAILURE,
  CHECK_MER_PRODUCT_ID_FAILURE,
  CHECK_MER_PRODUCT_ID_REQUEST,
  CHECK_MER_PRODUCT_ID_SUCCESS
} from 'stores/flow-type/variants-display.type';
import { trackFSEvent } from 'src/integrations/fullStory';

/**
 * get search settings
 * @return {object} The RSAA object for API middleware
 */
export const getVariantsDisplay = (i18n: I18n) => {
  return apiService.sendRequest('admin-v3.variants-display.get-variants-display', {}, [
    GET_VARIANTS_DISPLAY_REQUEST,
    {
      type: GET_VARIANTS_DISPLAY_SUCCESS,
      payload: async (action, state, res) => {
        const data = await getJSON(res);

        return { data };
      }
    },
    {
      type: GET_VARIANTS_DISPLAY_FAILURE,
      payload: async (action, state, res) =>
        await processRes(
          res,
          'error',
          i18n.translate('AdminHTML.VariantsDisplay.Actions.getVariantsDisplay'),
          i18n
        )
    }
  ]);
};

/**
 * Update search settings
 * @return {object} The RSAA object for API middleware
 */
export const updateVariantsDisplay = (body, type = '', i18n: I18n) => {
  return apiService.sendRequest('admin-v3.variants-display.update-variants-display', { body }, [
    UPDATE_VARIANTS_DISPLAY_REQUEST,
    {
      type: UPDATE_VARIANTS_DISPLAY_SUCCESS,
      payload: async (action, state, res) => {
        const message = i18n.translate(
          'AdminHTML.VariantsDisplay.Actions.updateVariantsDisplay_Success'
        );
        const data = await processRes(res, 'custom-with-sync', message, i18n);
        if (body?.enable) {
          // Track Full Story event
          trackFSEvent('Enable Variant Display', {
            feature: 'Variant Display',
            searchPage: body?.appliesTo?.searchPage
          });
        } else {
          // Track Full Story event
          trackFSEvent('Disable Variant Display', {
            feature: 'Variant Display'
          });
        }
        return { data };
      }
    },
    {
      type: UPDATE_VARIANTS_DISPLAY_FAILURE,
      payload: async (action, state, res) => {
        const errorResult = await processRes(
          res,
          'error',
          i18n.translate('AdminHTML.VariantsDisplay.Actions.updateVariantsDisplay_Failure'),
          i18n
        );

        return errorResult;
      }
    }
  ]);
};

export const checkExistsMERProductId = (i18n: I18n) => {
  return apiService.sendRequest('admin-v3.merchandising-v2.check-productid', {}, [
    CHECK_MER_PRODUCT_ID_REQUEST,
    {
      type: CHECK_MER_PRODUCT_ID_SUCCESS,
      payload: async (action, state, res) => {
        const data = await getJSON(res);
        return { data };
      }
    },
    {
      type: CHECK_MER_PRODUCT_ID_FAILURE,
      payload: async (action, state, res) => {
        const errorResult = await processRes(
          res,
          'error',
          i18n.translate('AdminHTML.VariantsDisplay.Actions.checkExistsMERProductId_Failure'),
          i18n
        );

        return errorResult;
      }
    }
  ]);
};
